<i *ngIf="iconName !== IconType.None" [ngClass]="['d-flex', iconName, iconClass]" [attr.title]="tooltip" [style.font-size]="iconSize"></i>
